import { Outlet, useLocation } from '@solidjs/router';
import { createEffect, createSignal, on, Show } from 'solid-js';
import { useAuth, useCompanies } from '~/contexts/global';
import { IS_USER_LOGIN_FROM_INTERNAL_KEY } from '~/utils/constant';
import { Menu } from './Menu';
import { MenuProvider, useMenu } from './Menu/MenuContext';
import { Navigation } from './Navigation';

const useIntercom = () => {
  const location = useLocation();
  const { me } = useAuth();
  const { companies } = useCompanies();

  createEffect(
    on(
      () => [me()?.id, companies()?.id, companies()?.name],
      () => {
        if (!me()?.id || sessionStorage.getItem(IS_USER_LOGIN_FROM_INTERNAL_KEY) === 'true') return;
        window.Intercom('boot', {
          api_base: 'https://api-iam.intercom.io',
          app_id: 'yk2iavay',
          user_id: me()?.id,
          company: {
            id: companies()?.id,
            name: companies()?.name,
          },
          name: me()?.name,
          email: me()?.email,
          created_at: me()?.createdAt,
        });
      }
    )
  );

  createEffect(
    on(
      () => location.pathname,
      () => window.Intercom('update')
    )
  );
};

const useCobrowse = () => {
  const { me } = useAuth();
  createEffect(
    on(
      () => me()?.id,
      () => {
        if (!me()?.id) return;

        // Generate or retrieve device ID
        let deviceId = localStorage.getItem('device_id');
        if (!deviceId) {
          deviceId = crypto.randomUUID?.();
          localStorage.setItem('device_id', deviceId);
        }

        window.CobrowseIO.customData = {
          user_id: me()?.id,
          user_name: me()?.name,
          user_email: me()?.email,
          device_id: deviceId,
          device_name: 'PM - ' + me()?.name + ' - ' + me()?.email,
        };
      }
    )
  );
};

const Layout = () => {
  const [isSearchActive, setIsSearchActive] = createSignal<boolean>(false);

  useIntercom();
  useCobrowse();

  return (
    <MenuProvider>
      <LayoutContent isSearchActive={isSearchActive} setIsSearchActive={setIsSearchActive} />
    </MenuProvider>
  );
};

const LayoutContent = (props: { isSearchActive: () => boolean; setIsSearchActive: (value: boolean) => void }) => {
  const menu = useMenu();

  return (
    <div class="h-dvh bg-inputbox-bg pt-16">
      <div
        id="layout-content"
        class="flex h-full overflow-auto"
        classList={{
          'overflow-x-hidden': menu?.isSidebarOpen() && menu?.isMobile(),
        }}>
        <Menu />
        <main
          class="flex w-full grow flex-col"
          classList={{
            'md:pl-64': !menu?.isManuallyCollapsed(),
            'md:pl-16': menu?.isManuallyCollapsed(),
            'translate-x-[245px]': menu?.isSidebarOpen() && menu?.isMobile(),
          }}>
          <Navigation setIsSearchActive={props.setIsSearchActive} />

          <div class="flex-1">
            <Outlet />
          </div>
        </main>
        <Show when={props.isSearchActive()}>
          <div class="overlay fixed inset-0 z-40 bg-black/70" />
        </Show>
      </div>
    </div>
  );
};

export default Layout;
